import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./pages/app";
import * as serviceWorker from "./serviceWorker";
import "element-theme-default";
import { ConfigProvider } from "antd";
import { Provider } from "mobx-react";
import stores from "./store/index";
import zhCN from 'antd/es/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

ReactDOM.render(
  //将antd文案配置成中文
  <Provider {...stores}>
    <ConfigProvider locale={zhCN}>
      <App />
    </ConfigProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
